/**
 * @file Один набор действий для двух способов открытия меню.
 *
 * Обычное меню «⋯» и контекстное меню используют одинаковые пункты Base UI,
 * чтобы подписи, порядок действий и обработчики не расходились.
 */
import { FiDownload, FiEdit2, FiFolder, FiTrash2 } from 'react-icons/fi'

import { Menu } from '@base-ui/react'

import { fileMessages } from '../features/files/messages'
import { useLocale } from '../i18n/useLocale'

// ContextMenu использует ту же реализацию Menu.Item: общие пункты работают
// и по правому клику, и через видимую кнопку «⋯».
export default function FileContextMenu({
    isFolder,
    onOpen,
    onDownload,
    onDelete,
    onRename,
}: {
    isFolder: boolean
    onOpen: () => void
    onDownload: () => void
    onDelete: () => void
    onRename: () => void
}) {
    const { locale } = useLocale()
    const text = fileMessages[locale]

    return (
        <>
            {isFolder && (
                <Menu.Item className='file-menu-item' onClick={onOpen}>
                    <FiFolder aria-hidden='true' />
                    {text.open}
                </Menu.Item>
            )}
            <Menu.Item className='file-menu-item' onClick={onDownload}>
                <FiDownload aria-hidden='true' />
                {isFolder ? text.downloadFolder : text.download}
            </Menu.Item>
            <Menu.Item className='file-menu-item' onClick={onRename}>
                <FiEdit2 aria-hidden='true' />
                {text.rename}
            </Menu.Item>
            <Menu.Item
                className='file-menu-item file-menu-danger'
                onClick={onDelete}
            >
                <FiTrash2 aria-hidden='true' />
                {text.remove}
            </Menu.Item>
        </>
    )
}
